import { z } from 'zod';
import { UnusedSchema } from '../baseSchemas';
import { msObject } from '../msObject';
import {
    CategoryDefinition,
    Setting,
    SettingClass,
    SettingDefinition,
    SettingDefinitionMapping,
    UpdatedSetting,
} from './types';

const SettingClassSchema = z.enum(SettingClass);

export const UpdatedSettingSchema: z.ZodType<UpdatedSetting> = msObject({
    identifier: z.string(),
    value: z.any(),
});

const SettingDefinitionSchema: z.ZodType<SettingDefinition> = msObject({
    identifier: z.string(),
    defaultValue: z.any(),
    settingClass: SettingClassSchema,
    calculateEnabledStateFunction: UnusedSchema,
    valueClass: UnusedSchema,
});

const SettingSchema: z.ZodType<Setting> = msObject({
    settingDefinition: SettingDefinitionSchema,
    value: z.any(),
});

const CategoryDefinitionSchema: z.ZodType<CategoryDefinition> = msObject({
    identifier: z.string(),
    settings: SettingSchema.array(),
    get subSettingCategories(){
        return CategoryDefinitionSchema.array()
    },
});

export const SettingDefinitionMappingSchema: z.ZodType<SettingDefinitionMapping> = msObject({
    settings: SettingSchema.array(),
    categories: CategoryDefinitionSchema.array(),
    settingDefinitionCollection: UnusedSchema,
    transformationErrors: UnusedSchema,
});
